// Public, build-time configuration only. The anon key is public by design;
// service keys and LLM keys never reach the browser bundle.
export const env = {
  supabaseUrl: (import.meta.env.VITE_SUPABASE_URL as string | undefined) ?? 'http://127.0.0.1:54321',
  supabaseAnonKey: (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) ?? '',
  vapidPublicKey: (import.meta.env.VITE_VAPID_PUBLIC_KEY as string | undefined) ?? '',
};

/** /s/<slug>/... → slug, or null on the root page. */
export function tenantSlugFromPath(pathname = window.location.pathname): string | null {
  const m = /^\/s\/([a-z0-9](?:[a-z0-9-]{0,38}[a-z0-9])?)(?:\/|$)/.exec(pathname);
  return m ? m[1]! : null;
}

export const tenantBase = (slug: string) => `/s/${slug}`;
